<template>
	<div class="section">
		<div class="container">
			<h2>Flagged Profiles</h2>
			<div class="columns is-marginless">
				<div class="column">
					<b-input placeholder="Type a filter here.." @input="sortFilter" type="text" v-model="filter"></b-input>
				</div>
			</div>
			<div class="level">
				<div class="level-left">
					<b-button class="is-text" @click="sortName">Sort by Name</b-button>
					<b-button class="is-text" @click="sortTitle">Sort by Title</b-button>
					<b-button class="is-text" @click="sortSalary">Sort by Salary</b-button>
				</div>
				<div class="level-right">
					<p>
						Filter by flag color:
						<span>
							<i class="clickable" v-bind:class="{'fas fa-flag': flagFilter.Blue, 'far fa-flag': !flagFilter.Blue}" style="color:#337ab7" @click="filterFlag('Blue')"></i>&nbsp;
							<i class="clickable" v-bind:class="{'fas fa-flag': flagFilter.Red, 'far fa-flag': !flagFilter.Red}" style="color:#ff0000" @click="filterFlag('Red')"></i>&nbsp;
							<i class="clickable" v-bind:class="{'fas fa-flag': flagFilter.Green, 'far fa-flag': !flagFilter.Green}" style="color:#0aba00" @click="filterFlag('Green')"></i>&nbsp;
							<i class="clickable" v-bind:class="{'fas fa-flag': flagFilter.Purple, 'far fa-flag': !flagFilter.Purple}" style="color:#4800e4" @click="filterFlag('Purple')"></i>&nbsp;
							<i class="clickable" v-bind:class="{'fas fa-flag': flagFilter.Orange, 'far fa-flag': !flagFilter.Orange}" style="color:#ff6a00" @click="filterFlag('Orange')"></i>
						</span>
					</p>
				</div>
			</div>
			<loading v-if="isLoading == true"></loading>
			<div v-if="isLoading == false">
				<div class="columns is-multiline">
					<div class="column is-one-third" v-for="result in flagDisplay">
						<resultCard :result="result"></resultCard>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import loading from '@/components/other/loading.vue';
	import resultCard from "@/components/results/resultCard.vue";
	export default {
		components: {
			loading,
			resultCard
		},
		data() {
			return {
				fullList: [],
				isLoading: false,
				filter: '',
				displayList: [],
				flagFilter: {
					Blue: true,
					Red: true,
					Green: true,
					Purple: true,
					Orange: true
				}
			}
		},
		computed: {
			flagDisplay() {
				return this.displayList.filter(f => (this.flagFilter.Blue == true && f.FlagColor == '337ab7') || (this.flagFilter.Red == true && f.FlagColor == 'ff0000') || (this.flagFilter.Green == true && f.FlagColor == '0aba00') || (this.flagFilter.Purple == true && f.FlagColor == '4800e4') || (this.flagFilter.Orange == true && f.FlagColor == 'ff6a00'));
			},
		},
		created() {
			this.isLoading = true;
			var profiles = this.$store.getters.flagged.flagged;
			this.$http.get("api/profile/flagged/prune")
				.then(resp => {
					let results = [];
					results = resp.data;
					if (profiles.length > 0) {
						results.forEach(r => {
							profiles.some(p => {
								if (p.UserId == r.UserId) {
									r.FlagColor = p.Color;
									r.IsFlagged = true;
								}
							})
						})
					}
					this.fullList = results;
					this.displayList = results;
					this.isLoading = false;
				}).catch(e => {
					console.log(e);
					this.isLoading = false;
				})
		},
		methods: {
			filterFlag(color) {
				if (color == 'Red')
					if (this.flagFilter.Red)
						this.$set(this.flagFilter, 'Red', false);
					else
						this.$set(this.flagFilter, 'Red', true);
				if (color == 'Blue')
					if (this.flagFilter.Blue)
						this.$set(this.flagFilter, 'Blue', false);
					else
						this.$set(this.flagFilter, 'Blue', true);
				if (color == 'Green')
					if (this.flagFilter.Green)
						this.$set(this.flagFilter, 'Green', false);
					else
						this.$set(this.flagFilter, 'Green', true);
				if (color == 'Purple')
					if (this.flagFilter.Purple)
						this.$set(this.flagFilter, 'Purple', false);
					else
						this.$set(this.flagFilter, 'Purple', true);
				if (color == 'Orange')
					if (this.flagFilter.Orange)
						this.$set(this.flagFilter, 'Orange', false);
					else
						this.$set(this.flagFilter, 'Orange', true);
			},
			sortName() {
				this.$set(this, "displayList", this.displayList.sort((a, b) => (a.FirstName > b.FirstName) ? 1 : -1));
			},
			sortTitle() {
				this.displayList = this.displayList.sort((a, b) => (a.PresentJobTitles[0] > b.PresentJobTitles[0]) ? 1 : -1);
			},
			sortSalary() {
				this.displayList = this.displayList.sort((a, b) => (a.PresentCompensation < b.PresentCompensation) ? 1 : -1);
			},
			sortFilter() {
				if (this.filter != null && this.filter != "") {
					this.displayList = this.fullList.filter((option) => {
						if (option.FirstName && (option.FirstName.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0)) {
							return option
								.FirstName
								.toString()
								.toLowerCase()
								.indexOf(this.filter.toLowerCase()) >= 0;
						} else if (option.LastName && (option.LastName.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0)) {
							return option
								.LastName
								.toString()
								.toLowerCase()
								.indexOf(this.filter.toLowerCase()) >= 0;
						} else if (option.PresentJobTitles && (option.PresentJobTitles.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0)) {
							return option
								.PresentJobTitles
								.toString()
								.toLowerCase()
								.indexOf(this.filter.toLowerCase()) >= 0;
						} else if (option.PresentCompanies && (option.PresentCompanies.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0)) {
							return option
								.PresentCompanies
								.toString()
								.toLowerCase()
								.indexOf(this.filter.toLowerCase()) >= 0;
						}
					});
				}
				else {
					this.displayList = this.fullList;
				}
			}
		}
	}
</script>
